import { Client } from '@lemonade-hq/nuiza';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import { font, themedColor, fadeInAnimation } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { API_PREFIX_LEGACY } from '@/const/api';
import { useRouter } from 'next/router';

const PriceWrapper = styled.div`
  ${font('main', { fontSize: '1.4rem' })};
  animation: ${fadeInAnimation} 0.5s ease-in-out;
  margin-top: 40px;
  b {
    display: block;
  }

  a {
    color: ${themedColor('textPrimary')};
    font-weight: 700;
  }

  ${MEDIA_QUERIES.mobile`
    margin-top: -10px;
    b {
      display: inline;
    }
  `}
`;

type StockInfo = {
  c: number; // Current price
  d: number; // Change
  dp: number; // Change percentage
};

const getPrice = async (): Promise<{
  price: number;
  change: number;
  changePercentage: number;
}> => {
  // change this to call a handler
  const stockInfo = await Client.get<StockInfo>(
    `${process.env.NEXT_PUBLIC_MONOLITH_URL}/${API_PREFIX_LEGACY}/stock_price`,
  )
    .then(data => data)
    .catch(err => {
      console.error('stock price error', err);
      return {
        c: 0,
        d: 0,
        dp: 0,
      };
    });

  return {
    price: stockInfo.c,
    change: stockInfo.d,
    changePercentage: stockInfo.dp,
  };
};

const parsedStock = (value: number) => parseFloat(value.toString()).toFixed(2);

export const PricingWidget: React.FC = () => {
  const router = useRouter();
  const [{ price, change, changePercentage }, setPrice] = useState<{
    price: number;
    change: number;
    changePercentage: number;
  }>({
    price: 0,
    change: 0,
    changePercentage: 0,
  });

  useEffect(() => {
    void getPrice().then(setPrice);
  }, []);

  if (price === 0 || router.asPath.includes('stock-information')) return null;

  return (
    <PriceWrapper>
      <b>NYSE: LMND</b> <Link href="/investor/stock-information">${parsedStock(price)}</Link>{' '}
      {change > 0 ? `+${parsedStock(change)}` : parsedStock(change)} (
      {changePercentage > 0 ? `+${parsedStock(changePercentage)}` : parsedStock(changePercentage)}%)
    </PriceWrapper>
  );
};
